<template>
    <vue-scroll v-if="item" v-loading="loading">
        <div class="order-statuses">
            <table
                class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
                v-if="statuses"
            >
                <tbody>
                    <tr v-for="status in defaultStatuses">
                        <td style="width: 150px;">
                            <div class="cell">
                                <template
                                    v-if="
                                        !status.can_edit ||
                                            !isApproved ||
                                            item.is_closed
                                    "
                                >
                                    <i
                                        class="mdi mdi-checkbox-blank-outline"
                                        v-if="!status.checked"
                                    />
                                    <i
                                        class="mdi mdi-checkbox-marked success-text"
                                        v-else
                                    />
                                    {{ getOrderStatusFullName(status.status) }}
                                </template>
                                <el-checkbox v-else v-model="status.checked"
                                    >{{ getOrderStatusFullName(status.status) }}
                                </el-checkbox>
                            </div>
                        </td>
                        <td>
                            <div class="cell" v-if="status.updater">
                                {{ datetimeFormat(status.updated_at) }} by
                                <span class="bold">{{
                                    status.updater.name
                                }}</span>
                            </div>
                        </td>
                    </tr>
                    <template v-if="item.has_poster_shipment">
                        <tr>
                            <td colspan="2">
                                <div class="cell">Wall Posters</div>
                            </td>
                        </tr>
                        <tr v-for="status in statuses.wall_posters">
                            <td>
                                <div class="cell">
                                    <template
                                        v-if="
                                            !status.can_edit ||
                                                !isApproved ||
                                                item.is_closed
                                        "
                                    >
                                        <i
                                            class="mdi mdi-checkbox-blank-outline"
                                            v-if="!status.checked"
                                        />
                                        <i
                                            class="mdi mdi-checkbox-marked success-text"
                                            v-else
                                        />
                                        {{
                                            getOrderStatusFullName(
                                                status.status,
                                            )
                                        }}
                                    </template>
                                    <el-checkbox
                                        v-else
                                        v-model="status.checked"
                                    >
                                        {{
                                            getOrderStatusFullName(
                                                status.status,
                                            )
                                        }}
                                    </el-checkbox>
                                </div>
                            </td>
                            <td>
                                <div class="cell" v-if="status.updated_at">
                                    {{ datetimeFormat(status.updated_at) }}
                                    <span v-if="status.updater"
                                        >by
                                        <span class="bold">{{
                                            status.updater.name
                                        }}</span></span
                                    >
                                    <span v-if="getTrackingInfo(status)">
                                        - {{ getTrackingInfo(status) }}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-if="item.has_flat_shipment">
                        <tr>
                            <td colspan="2">
                                <div class="cell">Flats</div>
                            </td>
                        </tr>
                        <tr v-for="status in statuses.flats">
                            <td>
                                <div class="cell">
                                    <template
                                        v-if="
                                            !status.can_edit ||
                                                !isApproved ||
                                                item.is_closed
                                        "
                                    >
                                        <i
                                            class="mdi mdi-checkbox-blank-outline"
                                            v-if="!status.checked"
                                        />
                                        <i
                                            class="mdi mdi-checkbox-marked success-text"
                                            v-else
                                        />
                                        {{
                                            getOrderStatusFullName(
                                                status.status,
                                            )
                                        }}
                                    </template>
                                    <el-checkbox v-else v-model="status.checked"
                                        >{{
                                            getOrderStatusFullName(
                                                status.status,
                                            )
                                        }}
                                    </el-checkbox>
                                </div>
                            </td>
                            <td>
                                <div class="cell" v-if="status.updated_at">
                                    {{ datetimeFormat(status.updated_at) }}
                                    <span v-if="status.updater"
                                        >by
                                        <span class="bold">{{
                                            status.updater.name
                                        }}</span></span
                                    >
                                    <span v-if="getTrackingInfo(status)">
                                        - {{ getTrackingInfo(status) }}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="2">
                            <div class="cell closed-checkbox">
                                <i
                                    class="mdi mdi-checkbox-blank-outline"
                                    v-if="!orderClosed"
                                />
                                <i
                                    class="mdi mdi-checkbox-marked success-text"
                                    v-else
                                />
                                <span :class="{ 'success-text': orderClosed }"
                                    >Closed</span
                                >
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="float-left mt-10">
            <el-button
                :loading="form.busy"
                @click="submit()"
                icon="mdi mdi-content-save"
                type="primary"
                v-if="(canCheck || canUncheck) && isApproved && !item.is_closed"
            >
                Save Changes
            </el-button>
            <template
                v-if="!item.has_flat_shipment && !item.has_poster_shipment"
            >
                <el-divider
                    direction="vertical"
                    v-if="isApproved && !item.is_closed"
                />
                <label for="switch-close-order">
                    Order Closed
                    <el-switch
                        :disabled="closingOrder"
                        @change="onChangeOrderClosed"
                        id="switch-close-order"
                        v-model="closeForm.is_closed"
                    />
                </label>
            </template>
        </div>
        <div class="clearfix"></div>
    </vue-scroll>
</template>

<script>
import store from "@/store/index";
import { mapState } from "vuex";
import order_status_mixin from "@/mixins/order-status";
import * as ApprovalStatus from "@/constants/approval-status";
import * as Statuses from "@/constants/order-statuses";
import * as SizeTypes from "@/constants/size-types.js";
import * as AccountTypes from "@/constants/account-types";
import auth from "@/mixins/auth";
import * as Permissions from "@/constants/permissions";
import moment from "moment";
import _ from "lodash";
//uses https.js imported in window.App

function getData(id) {
    return window.axios.get(`/web-api/order/${id}`, {
        params: {
            include: store.state.orders.meta.include,
        },
    });
}

export default {
    mixins: [order_status_mixin, auth],
    props: {
        id: {
            required: true,
        },
    },
    data() {
        return {
            item: null,
            shipments: [],
            statuses: null,
            form: new Form({
                statuses: [],
            }),
            loading: false,
            closeForm: new Form({
                is_closed: false,
            }),
            closingOrder: false,
        };
    },
    created() {},
    mounted() {
        this.getData();
    },
    computed: {
        ...mapState({
            workflow: (state) => state.config.settings.workflow,
        }),
        orderClosed() {
            if (this.item.is_closed) {
                return true;
            }
            if (!this.statuses) {
                return false;
            }
            let closed = true;
            _.forEach(this.statuses, (section) => {
                _.forEach(section, (status) => {
                    if (!status.checked) {
                        closed = false;
                    }
                });
            });
            return closed;
        },
        isApproved() {
            return (
                this.item &&
                this.item.approval_status === ApprovalStatus.APPROVED
            );
        },
        defaultStatuses() {
            if (!this.statuses) {
                return [];
            }
            let tempStatuses = [];
            tempStatuses = this.statuses.default.filter((status) => {
                if (
                    ![
                        Statuses.EMAILED_TO_CLIENT,
                        Statuses.PDF_APPROVED,
                    ].includes(status.status)
                ) {
                    return true;
                } else {
                    if (
                        _.get(
                            this.item,
                            "ordered_newsletter_pdf_proof",
                            false,
                        ) &&
                        [
                            Statuses.EMAILED_TO_CLIENT,
                            Statuses.PDF_APPROVED,
                        ].includes(status.status)
                    ) {
                        return true;
                    }
                    if (
                        _.get(
                            this.item,
                            "ordered_newsletter_pdf_only",
                            false,
                        ) &&
                        status.status === Statuses.EMAILED_TO_CLIENT
                    ) {
                        return true;
                    }
                }
                return false;
            });
            return tempStatuses;
        },
        canCheck() {
            return this.can(Permissions.CHECK_ORDER_STATUS);
        },
        canUncheck() {
            return this.can(Permissions.UNCHECK_ORDER_STATUS);
        },
        canUpdateInvoiced() {
            return this.can(Permissions.UPDATE_INVOICED_ORDER_STATUS);
        },
        canUpdatePdfApproved() {
            return this.can(Permissions.UPDATE_PDF_APPROVED_STATUS);
        },
        canOverrideOrderStatus() {
            return this.can(Permissions.OVERRIDE_ORDER_STATUS);
        },
    },
    watch: {
        id() {
            this.getData();
        },
    },
    methods: {
        setData(response) {
            this.item = response.data;
            this.initStatuses();
            this.closeForm.is_closed = this.item.is_closed;
        },
        getData() {
            this.loading = true;
            getData(this.id)
                .then((response) => {
                    this.setData(response);
                })
                .finally(() => (this.loading = false));
            this.getShipments();
        },
        getShipments() {
            window.axios
                .get(`/web-api/order/${this.id}/shipment`)
                .then((response) => {
                    this.shipments = response.data.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        reload() {
            getData(this.id)
                .then((response) => {
                    this.setData(response);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        initStatuses() {
            let data = {};
            let workflow = _.includes(
                [
                    AccountTypes.CALENDARS_AND_NEWSLETTER,
                    AccountTypes.NEWSLETTER_ONLY,
                ],
                this.item.account_type,
            )
                ? this.workflow.newsletter
                : this.workflow.calendar;
            _.forEach(workflow, (section, section_name) => {
                let statuses = [];
                _.set(data, section_name, statuses);
                _.forEach(section, (status) => {
                    let existing = this.item.statuses.data.find(
                        (item) =>
                            item.status === status && item.checked === true,
                    );
                    let _status;
                    if (!existing) {
                        _status = {
                            status: status,
                            checked: false,
                            updater: null,
                            updated_at: null,
                        };
                    } else {
                        _status = _.pick(existing, [
                            "status",
                            "checked",
                            "updater",
                            "updated_at",
                        ]);
                    }

                    if (_status.status == "invoiced") {
                        _status.can_edit = this.canUpdateInvoiced;
                    } else if (_status.status == Statuses.PDF_APPROVED) {
                        _status.can_edit = this.canUpdatePdfApproved;
                    } else if (
                        (_status.updater &&
                            _status.checked &&
                            _status.updater.id == this.auth.user.id) ||
                        this.canOverrideOrderStatus
                    ) {
                        _status.can_edit = true;
                    } else {
                        _status.can_edit = !_status.checked && this.canCheck;
                    }
                    statuses.push(_status);
                });
            });
            //console.log(data);
            this.statuses = data;
        },
        getTrackingInfo(status) {
            if (
                ![
                    Statuses.FLATS_SHIPPED,
                    Statuses.WALL_POSTERS_SHIPPED,
                ].includes(status.status)
            ) {
                return null;
            }
            let size_type =
                status.status === Statuses.FLATS_SHIPPED
                    ? SizeTypes.FLAT
                    : SizeTypes.POSTER;
            let shipment = _.find(this.shipments, { size_type });
            if (!shipment) {
                return null;
            }
            return shipment.reference_number;
        },
        saveStatuses(close_order = false, un_close_order = false) {
            if (close_order || un_close_order) {
                this.closingOrder = true;
            }
            this.form.statuses = [];
            _.forEach(this.statuses, (section) => {
                _.forEach(section, (status) => {
                    this.form.statuses.push(
                        _.pick(status, ["status", "checked"]),
                    );
                });
            });
            return window.App.put(
                `/web-api/order/${this.item.id}/status?include=updater`,
                this.form
            )
                .then((response) => {
                    _.extend(this.item.statuses.data, response.data.data);
                    if (!close_order && !un_close_order) {
                        this.$notify.success({
                            message: "Changes have been saved.",
                        });
                        this.getData();
                        this.$emit("success");
                    } else {
                        window.App.post(
                            `/web-api/order/${this.item.id}/${
                                close_order ? "close" : "un-close"
                            }`,
                            this.closeForm
                        )
                            .then((response) => {
                                this.$notify.success({
                                    message: `Order has been ${
                                        close_order ? "closed" : "un-closed"
                                    }.`,
                                });
                                _.extend(this.item, response.data);
                                this.getData();
                                this.$emit("success");
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                    return response;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => (this.closingOrder = false));
        },
        submit() {
            this.saveStatuses();
        },
        closeOrder() {
            this.$confirm("Confirm close order?", "Confirmation", {
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                type: "info",
            })
                .then(() => {
                    this.saveStatuses(true);
                })
                .catch(() => {
                    // user cancelled
                });
        },
        onChangeOrderClosed(value) {
            let message = `Confirm ${value ? "close" : "un-close"} order?`;
            this.$confirm(message, "Confirmation", {
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                type: "info",
            })
                .then(() => {
                    this.saveStatuses(value, !value);
                })
                .catch(() => {
                    this.closeForm.is_closed = !value;
                });
        },
        datetimeFormat(status_date) {
            return moment(status_date).format("MMM DD, YYYY hh:mma");
        },
    },
};
</script>

<style lang="scss" scoped>
.order-statuses {
    max-width: 700px;

    .el-table--group::after,
    .el-table--border::after,
    .el-table::before {
        content: none;
    }

    .closed-checkbox {
        i {
            font-size: 1rem;
            margin-left: -3px;
        }
    }
}
</style>
<style lang="scss">
@import "../../../../assets/scss/variables";

.order-statuses {
    .el-checkbox__input.is-checked + .el-checkbox__label {
        color: $text-color-success;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: $text-color-success;
        border-color: $text-color-success;
    }
}
</style>
